import { useMediaQuery } from '@mui/material';
import { useLayoutEffect, useRef } from 'react';
import { helixTokens } from '../theme/tokens';

// Animate the existing content element, never key/remount the Outlet or its providers.
export function useRouteMotion(pathname: string) {
  const ref = useRef<HTMLDivElement>(null);
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const routeKey = pathname.startsWith('/inbox') ? '/inbox' : pathname;
  const previous = useRef(routeKey);
  useLayoutEffect(() => {
    const changed = previous.current !== routeKey;
    previous.current = routeKey;
    const element = ref.current;
    if (!changed || routeKey === '/inbox' || reducedMotion || !element?.animate) return;
    const animation = element.animate(
      [
        { opacity: 0, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      { duration: helixTokens.motion.page, easing: helixTokens.motion.standard },
    );
    return () => animation.cancel();
  }, [routeKey, reducedMotion]);
  return ref;
}
